<template>
  <div class="wall">
    <div class="fs-12 color-lightGray">
      <div class="mt-10 flex-body-line">
        <a href="https://t4rcevdhb6.feishu.cn/docs/doccnO8qL95dNjZ6PgKldvtvBKd" target="_blank">
          · 红袜子成功与金蝶管易云ERP达成战略合作伙伴关系
        </a>
      </div>
      <div class="mt-10 flex-body-line">
        <router-link to="/">
          · 营销功能正式上线！
        </router-link>
      </div>
      <div class="mt-10 flex-body-line">
        <a
          href="https://fulishe-static.oss-cn-zhangjiakou.aliyuncs.com/static/docs/%E7%BA%A2%E8%A2%9C%E5%AD%90%E4%B8%9A%E5%8A%A1%E4%BF%9D%E8%AF%81%E9%87%91%E7%AE%A1%E7%90%86%E8%A7%84%E5%AE%9A.pdf"
          target="_blank"
        >· 《红袜子业务保证金管理规定》</a>
      </div>
      <div class="mt-10 flex-body-line">
        <router-link to="/">
          · 帮助中心
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {}
  }
}
</script>

<style lang="scss" scoped>
</style>